(function () {
  'use strict';

  var COUPON_FLAG = 'am2pmCouponAttempt';
  var chain = Promise.resolve();
  var pending = 0;

  function routeFor(key, fallback) {
    var routes = window.routes || (window.Shopify && window.Shopify.routes) || {};
    return routes[key] || fallback;
  }

  function roots() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-cart-extras]'));
  }

  function rootFor(context) {
    return document.querySelector('[data-cart-extras][data-context="' + context + '"]') || roots()[0] || null;
  }

  function contextOf(node) {
    var el = node ? node.closest('[data-cart-extras]') : null;
    return el ? el.getAttribute('data-context') : null;
  }

  function setBusy(state) {
    roots().forEach(function (el) { el.classList.toggle('is-busy', state); });
  }

  function showError(el, message) {
    var box = el ? el.querySelector('[data-coupon-error]') : null;
    if (!box) return;
    box.textContent = message || '';
    box.hidden = !message;
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw new Error(data && data.description ? data.description : 'Warenkorb konnte nicht aktualisiert werden.');
        return data;
      });
    });
  }

  function addLine(variantId, quantity) {
    return post(routeFor('cart_add_url', '/cart/add') + '.js', {
      items: [{ id: Number(variantId), quantity: quantity }]
    });
  }

  function changeLine(key, quantity) {
    return post(routeFor('cart_change_url', '/cart/change') + '.js', { id: key, quantity: quantity });
  }

  function holdScroll(context) {
    var selector = '[data-cart-extras][data-context="' + context + '"]';
    var anchor = context === 'side-cart' ? document.querySelector(selector) : null;
    var scroller = anchor ? anchor.closest('.halo-sidebar-wrapper') : null;
    if (!scroller) return function () {};
    var offset = anchor.getBoundingClientRect().top - scroller.getBoundingClientRect().top;
    function restore() {
      var current = scroller.querySelector(selector);
      if (!current) return;
      var delta = current.getBoundingClientRect().top - scroller.getBoundingClientRect().top - offset;
      if (Math.abs(delta) > 0.5) scroller.scrollTop += delta;
    }
    var observer = new MutationObserver(restore);
    observer.observe(scroller, { childList: true, subtree: true });
    return function () {
      restore();
      setTimeout(function () {
        restore();
        observer.disconnect();
      }, 400);
    };
  }

  function refresh(context) {
    var releaseScroll = holdScroll(context);
    return fetch(routeFor('cart_url', '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (context === 'main-cart' && window.halo && typeof window.halo.updateCart === 'function') {
          window.halo.updateCart(cart);
        } else if (window.halo && typeof window.halo.updateSidebarCart === 'function') {
          window.halo.updateSidebarCart(cart);
        } else {
          window.location.reload();
          return cart;
        }
        return new Promise(function (resolve) {
          var settled = false;
          function done() {
            if (settled) return;
            settled = true;
            document.removeEventListener('cart-update', done);
            releaseScroll();
            setTimeout(function () { resolve(cart); }, 60);
          }
          document.addEventListener('cart-update', done);
          setTimeout(done, 8000);
        });
      });
  }

  function enqueue(context, work) {
    pending += 1;
    setBusy(true);
    chain = chain
      .then(function () {
        var el = rootFor(context);
        if (!el) return null;
        showError(el, '');
        var job = work(el);
        if (!job) return null;
        return job.then(function () { return refresh(context); });
      })
      .catch(function (err) {
        showError(rootFor(context), err && err.message ? err.message : String(err));
      })
      .then(function () {
        pending -= 1;
        if (pending === 0) {
          setBusy(false);
          syncAll();
        }
      });
    return chain;
  }

  function guaranteeVariantFor(el, cents) {
    var map;
    try {
      map = JSON.parse(el.getAttribute('data-tg-variants') || '{}');
    } catch (e) {
      map = {};
    }
    if (map[cents]) return map[cents];
    var prices = Object.keys(map).map(Number).sort(function (a, b) { return a - b; });
    if (!prices.length) return null;
    var nearest = prices[0];
    for (var i = 0; i < prices.length; i++) {
      if (Math.abs(prices[i] - cents) < Math.abs(nearest - cents)) nearest = prices[i];
    }
    return map[nearest];
  }

  function guaranteeWork(wanted) {
    return function (el) {
      var key = el.getAttribute('data-tg-key');
      if (!wanted) return key ? changeLine(key, 0) : null;

      var cents = parseInt(el.getAttribute('data-tg-cents'), 10) || 0;
      var variantId = guaranteeVariantFor(el, cents);
      if (!variantId) return Promise.reject(new Error('Transportgarantie ist derzeit nicht verfügbar.'));
      if (!key) return addLine(variantId, 1);

      var currentVariant = key.split(':')[0];
      if (String(currentVariant) === String(variantId)) return null;

      var updates = {};
      updates[currentVariant] = 0;
      updates[variantId] = 1;
      return post(routeFor('cart_update_url', '/cart/update') + '.js', { updates: updates });
    };
  }

  function donationWork(kind, resolveFrancs) {
    return function (el) {
      var current = parseInt(el.getAttribute('data-' + kind + '-qty'), 10) || 0;
      var francs = resolveFrancs(current);
      if (francs === current) return null;

      var key = el.getAttribute('data-' + kind + '-key');
      if (!francs) return key ? changeLine(key, 0) : null;
      if (key) return changeLine(key, francs);

      var variantId = el.getAttribute('data-' + kind + '-variant');
      if (!variantId) return Promise.reject(new Error('Spende ist derzeit nicht verfügbar.'));
      return addLine(variantId, francs);
    };
  }

  var lastSyncedTarget = null;

  function syncGuarantee(el) {
    if (pending > 0) return;

    var key = el.getAttribute('data-tg-key');
    if (!key) {
      lastSyncedTarget = null;
      return;
    }

    var target = parseInt(el.getAttribute('data-tg-cents'), 10) || 0;
    var wanted = guaranteeVariantFor(el, target);
    if (!wanted) return;

    if (String(key.split(':')[0]) === String(wanted)) {
      lastSyncedTarget = null;
      return;
    }

    if (lastSyncedTarget === target) return;
    lastSyncedTarget = target;
    enqueue(el.getAttribute('data-context'), guaranteeWork(true));
  }

  function applyCoupon(el) {
    var input = el.querySelector('[data-coupon-input]');
    var code = input ? input.value.trim() : '';
    if (!code) {
      showError(el, 'Bitte geben Sie einen Rabattcode ein.');
      return;
    }
    var context = el.getAttribute('data-context');
    var updateUrl = routeFor('cart_update_url', '/cart/update') + '.js';
    enqueue(context, function () {
      return fetch(routeFor('cart_url', '/cart') + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (current) {
          var kept = (current.discount_codes || [])
            .filter(function (d) { return d.applicable && String(d.code).toLowerCase() !== code.toLowerCase(); })
            .map(function (d) { return d.code; });
          return post(updateUrl, { discount: kept.concat(code).join(',') }).then(function (cart) {
            if (!cart || !Array.isArray(cart.discount_codes)) {
              redirectCoupon(code);
              return new Promise(function () {});
            }
            var hit = cart.discount_codes.some(function (d) {
              return d.applicable && String(d.code).toLowerCase() === code.toLowerCase();
            });
            if (hit) return cart;
            return post(updateUrl, { discount: kept.join(',') }).then(function () {
              throw new Error('Der Rabattcode «' + code + '» ist ungültig oder nicht auf diese Bestellung anwendbar.');
            });
          });
        });
    });
  }

  function redirectCoupon(code) {
    try {
      sessionStorage.setItem(COUPON_FLAG, code);
    } catch (e) {}
    var target = window.location.pathname + window.location.search;
    window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(target);
  }

  function verifyCoupon() {
    var attempted;
    try {
      attempted = sessionStorage.getItem(COUPON_FLAG);
      if (attempted) sessionStorage.removeItem(COUPON_FLAG);
    } catch (e) {
      return;
    }
    if (!attempted) return;

    fetch(routeFor('cart_url', '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var hit = (cart.discount_codes || []).some(function (d) {
          return d.applicable && String(d.code).toLowerCase() === attempted.toLowerCase();
        });
        if (hit) return;
        roots().forEach(function (el) {
          var panel = el.querySelector('[data-coupon-panel]');
          var toggle = el.querySelector('[data-coupon-toggle]');
          if (panel) panel.hidden = false;
          if (toggle) toggle.setAttribute('aria-expanded', 'true');
          showError(el, 'Der Rabattcode «' + attempted + '» ist ungültig oder nicht auf diese Bestellung anwendbar.');
        });
      })
      .catch(function () {});
  }

  document.addEventListener('change', function (event) {
    var toggle = event.target.closest('[data-tg-toggle]');
    if (!toggle) return;
    var context = contextOf(toggle);
    if (!context) return;
    enqueue(context, guaranteeWork(toggle.checked));
  });

  document.addEventListener('click', function (event) {
    var preset = event.target.closest('[data-donation-preset]');
    if (preset) {
      var group = preset.closest('[data-donation-options]');
      var context = contextOf(preset);
      if (!group || !context) return;
      var kind = group.getAttribute('data-donation-options');
      var francs = parseInt(preset.getAttribute('data-donation-preset'), 10) || 0;
      enqueue(context, donationWork(kind, function (current) {
        return current === francs ? 0 : francs;
      }));
      return;
    }

    var couponToggle = event.target.closest('[data-coupon-toggle]');
    if (couponToggle) {
      var host = couponToggle.closest('[data-cart-extras]');
      var panel = host ? host.querySelector('[data-coupon-panel]') : null;
      if (!panel) return;
      var open = panel.hidden;
      panel.hidden = !open;
      couponToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        var field = panel.querySelector('[data-coupon-input]');
        if (field) field.focus();
      }
      return;
    }

    var apply = event.target.closest('[data-coupon-apply]');
    if (apply) {
      var couponHost = apply.closest('[data-cart-extras]');
      if (couponHost) applyCoupon(couponHost);
    }
  });

  function commitCustom(input) {
    if (!input.isConnected) return;
    var group = input.closest('[data-donation-options]');
    var context = contextOf(input);
    if (!group || !context) return;
    var kind = group.getAttribute('data-donation-options');
    var francs = parseInt(input.value.replace(/[^\d]/g, ''), 10) || 0;
    if (francs > 9999) francs = 9999;
    input.value = francs ? 'CHF ' + francs + '.–' : '';
    enqueue(context, donationWork(kind, function () { return francs; }));
  }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;

    var donation = event.target.closest('[data-donation-custom]');
    if (donation) {
      event.preventDefault();
      donation.blur();
      return;
    }

    var coupon = event.target.closest('[data-coupon-input]');
    if (coupon) {
      event.preventDefault();
      var el = coupon.closest('[data-cart-extras]');
      if (el) applyCoupon(el);
    }
  });

  function showCustomDigits(input) {
    var digits = input.value.replace(/[^\d]/g, '').slice(0, 4);
    input.value = digits ? 'CHF ' + digits : '';
  }

  document.addEventListener('input', function (event) {
    var input = event.target.closest && event.target.closest('[data-donation-custom]');
    if (input) showCustomDigits(input);
  });

  document.addEventListener('focus', function (event) {
    var input = event.target.closest && event.target.closest('[data-donation-custom]');
    if (input) showCustomDigits(input);
  }, true);

  document.addEventListener('blur', function (event) {
    var input = event.target.closest && event.target.closest('[data-donation-custom]');
    if (input) commitCustom(input);
  }, true);

  var EXTRA_HANDLES = ['transportgarantie', 'spende-schweizer-sozialprojekt', 'spende-schweizer-umweltprojekt'];
  var REORDER_BACKUP = 'am2pmCartReorder';

  function isExtra(item) {
    return EXTRA_HANDLES.indexOf(item.handle) !== -1;
  }

  function fetchCart() {
    return fetch(routeFor('cart_url', '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function linePayload(item) {
    var line = { id: item.variant_id, quantity: item.quantity };
    if (item.properties && Object.keys(item.properties).length) line.properties = item.properties;
    if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
      line.selling_plan = item.selling_plan_allocation.selling_plan.id;
    }
    return line;
  }

  function lineSignature(line) {
    return String(line.id) + '|' + JSON.stringify(line.properties || {}) + '|' + String(line.selling_plan || '');
  }

  function storeBackup(lines) {
    try {
      if (lines) sessionStorage.setItem(REORDER_BACKUP, JSON.stringify(lines));
      else sessionStorage.removeItem(REORDER_BACKUP);
    } catch (e) {}
  }

  function addLines(lines) {
    var url = routeFor('cart_add_url', '/cart/add') + '.js';
    return post(url, { items: lines }).catch(function () {
      return lines.reduce(function (queue, line) {
        return queue.then(function () {
          return post(url, { items: [line] }).catch(function () {});
        });
      }, Promise.resolve());
    });
  }

  var ORDER_STORE = 'am2pmLineOrder';
  var REPLACE_STORE = 'am2pmLineReplace';
  var freshLines = {};

  function readOrder() {
    try {
      var value = JSON.parse(localStorage.getItem(ORDER_STORE) || 'null');
      return Array.isArray(value) ? value : null;
    } catch (e) {
      return null;
    }
  }

  function writeOrder(keys) {
    try { localStorage.setItem(ORDER_STORE, JSON.stringify(keys)); } catch (e) {}
  }

  function readReplace() {
    try {
      var value = JSON.parse(sessionStorage.getItem(REPLACE_STORE) || 'null');
      if (value && Date.now() - value.at < 60000) return value;
    } catch (e) {}
    return null;
  }

  function clearReplace() {
    try { sessionStorage.removeItem(REPLACE_STORE); } catch (e) {}
  }

  function syncLineOrder(cartKeys) {
    var stored = readOrder();
    if (!cartKeys.length) {
      writeOrder([]);
      return [];
    }
    if (!stored) {
      var initial = cartKeys.slice().reverse();
      writeOrder(initial);
      return initial;
    }
    var added = cartKeys.filter(function (key) { return stored.indexOf(key) === -1; }).reverse();
    var variantOf = function (key) { return String(key).split(':')[0]; };
    var replace = readReplace();
    var at = -1;
    var kept = [];
    stored.forEach(function (key) {
      if (replace && key === replace.key && cartKeys.indexOf(key) === -1) at = kept.length;
      if (cartKeys.indexOf(key) !== -1) {
        kept.push(key);
        return;
      }
      for (var i = 0; i < added.length; i += 1) {
        if (variantOf(added[i]) === variantOf(key)) {
          kept.push(added.splice(i, 1)[0]);
          if (key === (replace && replace.key)) at = -1;
          return;
        }
      }
    });
    if (added.length) {
      if (at >= 0) {
        Array.prototype.splice.apply(kept, [at, 0].concat(added));
        clearReplace();
      } else {
        kept = kept.concat(added);
        added.forEach(function (key) { freshLines[key] = Date.now(); });
      }
    }
    if (kept.join('|') !== stored.join('|')) writeOrder(kept);
    return kept;
  }

  function sortMerchandise(items) {
    var order = syncLineOrder(items.map(function (item) { return item.key; }));
    return items.slice().sort(function (a, b) {
      var ia = order.indexOf(a.key);
      var ib = order.indexOf(b.key);
      return (ia === -1 ? order.length : ia) - (ib === -1 ? order.length : ib);
    });
  }

  function orderedLines(items) {
    var merchandise = sortMerchandise(items.filter(function (item) { return !isExtra(item); }));
    var extras = items.filter(isExtra).sort(function (a, b) {
      return EXTRA_HANDLES.indexOf(a.handle) - EXTRA_HANDLES.indexOf(b.handle);
    });
    return merchandise.concat(extras);
  }

  function reorderExtrasLast() {
    return fetchCart().then(function (cart) {
      var items = cart.items || [];
      var wanted = orderedLines(items);
      var keep = wanted.length;
      var cursor = items.length - 1;
      while (keep > 0) {
        var at = cursor;
        while (at >= 0 && items[at] !== wanted[keep - 1]) at -= 1;
        if (at < 0) break;
        cursor = at - 1;
        keep -= 1;
      }
      if (!keep) return null;

      var moved = wanted.slice(0, keep);
      var lines = moved.map(linePayload).reverse();
      var updates = {};
      moved.forEach(function (item) { updates[item.key] = 0; });

      storeBackup(lines);
      return post(routeFor('cart_update_url', '/cart/update') + '.js', { updates: updates })
        .then(function () { return addLines(lines); })
        .then(function () { storeBackup(null); });
    });
  }

  function restoreBackup() {
    var lines;
    try {
      lines = JSON.parse(sessionStorage.getItem(REORDER_BACKUP) || 'null');
    } catch (e) {
      return;
    }
    if (!lines || !lines.length) return;

    chain = chain
      .then(fetchCart)
      .then(function (cart) {
        var present = {};
        (cart.items || []).forEach(function (item) { present[lineSignature(linePayload(item))] = true; });
        var missing = lines.filter(function (line) { return !present[lineSignature(line)]; });
        if (!missing.length) return null;
        return addLines(missing).then(function () { window.location.reload(); });
      })
      .catch(function () {})
      .then(function () { storeBackup(null); });
  }

  var checkoutPass = false;
  var checkoutHeld = false;

  document.addEventListener('click', function (event) {
    var button = event.target.closest ? event.target.closest('#cart-checkout, #cart-sidebar-checkout') : null;
    if (!button || button.disabled) return;
    if (checkoutPass) {
      checkoutPass = false;
      return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    if (checkoutHeld) return;
    checkoutHeld = true;
    button.classList.add('is-loading');
    chain = chain
      .then(reorderExtrasLast)
      .catch(function () {})
      .then(function () {
        checkoutHeld = false;
        checkoutPass = true;
        button.click();
        checkoutPass = false;
      });
  }, true);

  function setInfoOpen(info, open) {
    info.classList.toggle('is-open', open);
    var button = info.querySelector('[data-shipping-info-toggle]');
    if (button) button.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  document.addEventListener('click', function (event) {
    if (!document.body.classList.contains('template-cart')) return;
    if (event.target.closest('#halo-cart-sidebar')) return;
    var info = event.target.closest('[data-shipping-info]');
    var toggle = event.target.closest('[data-shipping-info-toggle]');
    document.querySelectorAll('[data-shipping-info].is-open').forEach(function (open) {
      if (open === info || open.closest('#halo-cart-sidebar') || open.closest('free-shipping-component')) return;
      setInfoOpen(open, false);
    });
    if (!toggle || !info || info.closest('free-shipping-component')) return;
    event.preventDefault();
    var willOpen = !info.classList.contains('is-open');
    setInfoOpen(info, willOpen);
    if (!willOpen) toggle.blur();
  }, true);

  var pageInfoDim;
  var pageInfoDimRaf;

  function placePageInfoDim() {
    pageInfoDimRaf = null;
    if (!document.body.classList.contains('template-cart')) return;
    var popup = null;
    document.querySelectorAll('[data-shipping-info].is-open .shippingInfo__popup').forEach(function (candidate) {
      if (!popup && !candidate.closest('#halo-cart-sidebar')) popup = candidate;
    });
    if (!pageInfoDim) {
      if (!popup) return;
      pageInfoDim = document.createElement('div');
      pageInfoDim.className = 'am2pm-page-info-dim';
      pageInfoDim.setAttribute('aria-hidden', 'true');
      document.body.appendChild(pageInfoDim);
    }
    if (!popup) {
      pageInfoDim.classList.remove('is-visible');
      return;
    }
    var rect = popup.getBoundingClientRect();
    var w = window.innerWidth;
    var h = window.innerHeight;
    var x = rect.left;
    var y = rect.top;
    var rw = rect.width;
    var rh = rect.height;
    var r = Math.min(8, rw / 2, rh / 2);
    pageInfoDim.style.clipPath = 'path(evenodd, "M0 0H' + w + 'V' + h + 'H0Z'
      + 'M' + (x + r) + ' ' + y + 'H' + (x + rw - r) + 'A' + r + ' ' + r + ' 0 0 1 ' + (x + rw) + ' ' + (y + r)
      + 'V' + (y + rh - r) + 'A' + r + ' ' + r + ' 0 0 1 ' + (x + rw - r) + ' ' + (y + rh)
      + 'H' + (x + r) + 'A' + r + ' ' + r + ' 0 0 1 ' + x + ' ' + (y + rh - r)
      + 'V' + (y + r) + 'A' + r + ' ' + r + ' 0 0 1 ' + (x + r) + ' ' + y + 'Z")';
    pageInfoDim.classList.add('is-visible');
  }

  function queuePageInfoDim() {
    if (!pageInfoDimRaf) pageInfoDimRaf = requestAnimationFrame(placePageInfoDim);
  }

  document.addEventListener('click', function () {
    setTimeout(queuePageInfoDim, 0);
  }, true);
  document.addEventListener('keyup', queuePageInfoDim);
  window.addEventListener('scroll', queuePageInfoDim, { passive: true });
  window.addEventListener('resize', queuePageInfoDim);

  function pinCartActions() {
    var sidebar = document.getElementById('halo-cart-sidebar');
    if (!sidebar) return;
    var pinned = sidebar.querySelector(':scope > .previewCartAction');
    var fresh = sidebar.querySelector('.halo-sidebar-wrapper .previewCartAction');
    if (fresh) {
      if (pinned && pinned !== fresh) pinned.remove();
      sidebar.appendChild(fresh);
    } else if (pinned && !sidebar.querySelector('.previewCartList')) {
      pinned.remove();
    }
  }

  function liftCartSummary() {
    var wrapper = document.querySelector('.template-cart .cart-content-wrapper');
    var summary = wrapper ? wrapper.querySelector('[data-cart-total]') : null;
    var message = document.querySelector('.template-cart .cart-container .cart-message');
    if (!wrapper || !summary) return;
    wrapper.style.setProperty('--cart-summary-lift', '0px');
    var title = summary.querySelector('.cart--totals-title') || summary;
    var titleBox = title.getBoundingClientRect();
    var inset = title === summary ? 0 : Math.max(0, (titleBox.height - parseFloat(getComputedStyle(title).fontSize) * 0.72) / 2);
    var lift = message ? titleBox.top + inset - message.getBoundingClientRect().top : 0;
    wrapper.style.setProperty('--cart-summary-lift', Math.max(0, Math.round(lift)) + 'px');
  }

  function fitCartVariantText() {
    document.querySelectorAll('.template-cart .cart-item-detail-row--variant').forEach(function (row) {
      var text = row.querySelector(':scope > span');
      if (!text) return;
      text.style.width = '';
      var right = 0;
      text.querySelectorAll('.cart-item-detail-label, .cart-item-detail-value').forEach(function (part) {
        Array.prototype.forEach.call(part.getClientRects(), function (rect) {
          if (rect.right > right) right = rect.right;
        });
      });
      if (right) text.style.width = Math.ceil(right - text.getBoundingClientRect().left) + 1 + 'px';
    });
  }

  function layoutCartPage() {
    liftCartSummary();
    fitCartVariantText();
  }

  window.addEventListener('resize', layoutCartPage);
  function watchCartMessage() {
    var message = document.querySelector('.template-cart .cart-container .cart-message');
    if (!message || message.hasAttribute('data-lift-watched')) return;
    message.setAttribute('data-lift-watched', '');
    if (window.ResizeObserver) new ResizeObserver(liftCartSummary).observe(message);
    new MutationObserver(function () {
      requestAnimationFrame(liftCartSummary);
    }).observe(message, { childList: true, subtree: true, characterData: true });
  }

  window.addEventListener('load', function () {
    layoutCartPage();
    [300, 1000, 2500].forEach(function (delay) { setTimeout(layoutCartPage, delay); });
  });

  function syncAll() {
    pinCartActions();
    watchCartMessage();
    layoutCartPage();
    roots().forEach(syncGuarantee);
  }

  var EXTRA_ROW_CLASSES = ['cartExtras-line--guarantee', 'cartExtras-line--social', 'cartExtras-line--eco'];

  function extraRank(row) {
    for (var i = 0; i < EXTRA_ROW_CLASSES.length; i += 1) {
      if (row.classList.contains(EXTRA_ROW_CLASSES[i])) return i;
    }
    return -1;
  }

  function linePos(row) {
    return Number(row.getAttribute('data-am2pm-line-pos')) || 0;
  }

  function orderRows(container) {
    var rows = Array.prototype.filter.call(container.children, function (child) {
      return child.hasAttribute('data-am2pm-line-key');
    });
    if (!rows.length) return;
    var byPos = rows.slice().sort(function (a, b) { return linePos(a) - linePos(b); });
    var merchandise = byPos.filter(function (row) { return extraRank(row) === -1; });
    var extras = byPos.filter(function (row) { return extraRank(row) !== -1; }).sort(function (a, b) {
      return extraRank(a) - extraRank(b);
    });
    var order = syncLineOrder(merchandise.map(function (row) { return row.getAttribute('data-am2pm-line-key'); }));
    merchandise.sort(function (a, b) {
      return order.indexOf(a.getAttribute('data-am2pm-line-key')) - order.indexOf(b.getAttribute('data-am2pm-line-key'));
    });
    var wanted = merchandise.concat(extras);
    var same = wanted.every(function (row, i) { return row === rows[i]; });
    if (!same) {
      var anchor = rows[rows.length - 1].nextSibling;
      wanted.forEach(function (row) { container.insertBefore(row, anchor); });
    }
    var now = Date.now();
    merchandise.forEach(function (row) {
      var started = freshLines[row.getAttribute('data-am2pm-line-key')];
      if (!started || now - started >= 3500 || row.classList.contains('am2pm-line-new')) return;
      row.style.animationDelay = (started - now) + 'ms';
      row.classList.add('am2pm-line-new');
      bandLine(row, started);
      row.addEventListener('animationend', function () {
        row.classList.remove('am2pm-line-new');
        row.style.animationDelay = '';
      }, { once: true });
    });
  }

  function bandLine(row, started) {
    var scroller = row.closest('#halo-cart-sidebar .halo-sidebar-wrapper');
    if (!scroller) return;
    var key = row.getAttribute('data-am2pm-line-key');
    scroller.am2pmBandRow = row;
    scroller.classList.remove('am2pm-line-band');
    void scroller.offsetWidth;
    scroller.style.animationDelay = (started - Date.now()) + 'ms';
    scroller.classList.add('am2pm-line-band');
    if (scroller.am2pmPinKey !== key) {
      scroller.am2pmPinKey = key;
      scroller.am2pmPinUntil = Date.now() + 1200;
      if (!scroller.am2pmPinListen) {
        scroller.am2pmPinListen = true;
        ['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach(function (type) {
          scroller.addEventListener(type, function () { scroller.am2pmPinUntil = 0; }, { passive: true });
        });
      }
    }
    (function place() {
      if (scroller.am2pmBandRow !== row) return;
      if (!row.isConnected || Date.now() - started >= 3500) {
        scroller.am2pmBandRow = null;
        scroller.classList.remove('am2pm-line-band');
        scroller.style.animationDelay = '';
        scroller.style.removeProperty('--am2pm-line-band-y');
        scroller.style.removeProperty('--am2pm-line-band-h');
        return;
      }
      var box = scroller.getBoundingClientRect();
      var rect = row.getBoundingClientRect();
      var first = !row.previousElementSibling || !row.previousElementSibling.matches('.previewCartItem');
      if (Date.now() < scroller.am2pmPinUntil && box.height > 0) {
        var target = first ? 0 : Math.round(scroller.scrollTop + rect.top - box.top - scroller.clientTop + 2);
        if (Math.abs(scroller.scrollTop - target) > 1) {
          scroller.scrollTop = target;
          box = scroller.getBoundingClientRect();
          rect = row.getBoundingClientRect();
        }
      }
      var top = rect.top - box.top - scroller.clientTop;
      if (first) top = -scroller.scrollTop;
      var bottom = rect.bottom;
      var next = row.nextElementSibling;
      while (next && (!next.matches('.previewCartItem') || !next.offsetHeight)) next = next.nextElementSibling;
      if (!next) {
        var info = scroller.querySelector('.previewCartInfo');
        if (info && info.offsetHeight) bottom = Math.max(bottom, info.getBoundingClientRect().top);
      }
      scroller.style.setProperty('--am2pm-line-band-y', top + 'px');
      scroller.style.setProperty('--am2pm-line-band-h', (bottom - box.top - scroller.clientTop - top) + 'px');
      requestAnimationFrame(place);
    })();
  }

  function orderAllRows() {
    var containers = [];
    document.querySelectorAll('[data-am2pm-line-key]').forEach(function (row) {
      if (containers.indexOf(row.parentNode) === -1) containers.push(row.parentNode);
    });
    containers.forEach(orderRows);
    document.querySelectorAll('[data-am2pm-line-wait]').forEach(function (el) { el.removeAttribute('data-am2pm-line-wait'); });
  }

  var orderQueued = false;
  function queueOrder() {
    if (orderQueued) return;
    orderQueued = true;
    Promise.resolve().then(function () {
      orderQueued = false;
      orderAllRows();
    });
  }

  var rowObserver = new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i += 1) {
      var nodes = records[i].addedNodes;
      for (var j = 0; j < nodes.length; j += 1) {
        var node = nodes[j];
        if (node.nodeType === 1 && (node.hasAttribute('data-am2pm-line-key') || node.querySelector('[data-am2pm-line-key]'))) {
          queueOrder();
          return;
        }
      }
    }
  });
  document.querySelectorAll('#halo-cart-sidebar, cart-items').forEach(function (root) {
    rowObserver.observe(root.parentNode || root, { childList: true, subtree: true });
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest ? event.target.closest('#add-all-to-cart') : null;
    if (!button) return;
    var edit = document.querySelector('[data-template-cart-edit][data-line]');
    var key = edit ? edit.getAttribute('data-line') : '';
    if (!key) return;
    try { sessionStorage.setItem(REPLACE_STORE, JSON.stringify({ key: key, at: Date.now() })); } catch (e) {}
  }, true);

  document.addEventListener('cart-update', syncAll);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { restoreBackup(); verifyCoupon(); syncAll(); });
  } else {
    restoreBackup();
    verifyCoupon();
    syncAll();
  }
  orderAllRows();
})();

(function () {
  var FIELDS = '[data-am2pm-order-note-input], #cart-note, #Cart-note';
  var BACKUP = 'am2pmOrderNote';
  var current = null;
  var dirty = false;
  var timer = null;
  var chain = Promise.resolve();
  var token = null;

  function root() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return r.replace(/\/?$/, '/');
  }

  function fields() {
    return Array.prototype.slice.call(document.querySelectorAll(FIELDS));
  }

  function readBackup() {
    try { return JSON.parse(localStorage.getItem(BACKUP) || 'null'); } catch (e) { return null; }
  }

  function writeBackup(note) {
    try {
      if (note === null) localStorage.removeItem(BACKUP);
      else localStorage.setItem(BACKUP, JSON.stringify({ note: note, token: token, at: Date.now() }));
    } catch (e) {}
  }

  function openPanel(field) {
    var host = field.closest('[data-am2pm-order-note]');
    if (!host) return;
    var panel = host.querySelector('[data-am2pm-order-note-panel]');
    var toggle = host.querySelector('[data-am2pm-order-note-toggle]');
    if (panel && panel.hidden) panel.hidden = false;
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
  }

  var seen = typeof WeakSet === 'function' ? new WeakSet() : null;

  function apply(except) {
    if (current === null) return;
    fields().forEach(function (field) {
      var changed = false;
      if (field !== except && field.value !== current) {
        field.value = current;
        changed = true;
      }
      var fresh = seen ? !seen.has(field) : false;
      if (seen) seen.add(field);
      if (current !== '' && (changed || fresh)) openPanel(field);
    });
  }

  function send(keepalive) {
    clearTimeout(timer);
    timer = null;
    if (!dirty) return chain;
    var note = current;
    dirty = false;
    if (keepalive) {
      try {
        fetch(root() + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ note: note }),
          keepalive: true
        });
      } catch (e) {}
      return chain;
    }
    chain = chain.then(function () {
      return fetch(root() + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: note })
      }).then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.json();
      }).then(function (cart) {
        token = cart.token || token;
        if (!dirty && current === note) writeBackup(null);
      }).catch(function () {
        if (current === note) dirty = true;
        clearTimeout(timer);
        timer = setTimeout(function () { send(false); }, 3000);
      });
    });
    return chain;
  }

  function edited(field) {
    current = field.value;
    dirty = true;
    writeBackup(current);
    apply(field);
    clearTimeout(timer);
    timer = setTimeout(function () { send(false); }, 500);
  }

  function refresh() {
    return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        token = cart.token || null;
        var server = cart.note || '';
        var backup = readBackup();
        if (dirty) return;
        if (backup && backup.token && backup.token === token && backup.note !== server) {
          current = backup.note;
          dirty = true;
          apply(null);
          send(false);
          return;
        }
        if (backup) writeBackup(null);
        current = server;
        apply(null);
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest && event.target.closest('[data-am2pm-order-note-toggle]');
    if (!toggle) return;
    var host = toggle.closest('[data-am2pm-order-note]');
    var panel = host ? host.querySelector('[data-am2pm-order-note-panel]') : null;
    if (!panel) return;
    var open = panel.hidden;
    panel.hidden = !open;
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      var field = panel.querySelector('[data-am2pm-order-note-input]');
      if (field) field.focus();
    }
  });

  document.addEventListener('input', function (event) {
    var field = event.target.closest && event.target.closest(FIELDS);
    if (field) edited(field);
  });

  document.addEventListener('change', function (event) {
    if (event.target.closest && event.target.closest(FIELDS) && dirty) send(false);
  });

  document.addEventListener('pointerdown', function (event) {
    if (!dirty || !event.target.closest) return;
    if (event.target.closest('#cart-checkout, a[href*="checkout"], button[name="checkout"], [data-cart-checkout], .previewCartAction a, .previewCartAction button')) send(true);
  }, true);

  window.addEventListener('pagehide', function () { if (dirty) send(true); });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') { if (dirty) send(true); }
    else refresh();
  });
  window.addEventListener('pageshow', function (event) { if (event.persisted) refresh(); });
  window.addEventListener('storage', function (event) {
    if (event.key !== BACKUP) return;
    if (!event.newValue) { if (!dirty) refresh(); return; }
    try {
      var data = JSON.parse(event.newValue);
      if (dirty || typeof data.note !== 'string') return;
      current = data.note;
      apply(null);
    } catch (e) {}
  });

  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    Promise.resolve().then(function () {
      queued = false;
      var active = document.activeElement;
      apply(active && active.matches && active.matches(FIELDS) ? active : null);
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh);
  else refresh();
})();

document.addEventListener('click', function (event) {
  var toggle = event.target.closest && event.target.closest('.cart-note__head [data-shipping-info-toggle]');
  if (!toggle || !document.body.classList.contains('template-cart')) return;
  var info = toggle.closest('[data-shipping-info]');
  setTimeout(function () {
    requestAnimationFrame(function () {
      if (!info || !info.classList.contains('is-open')) return;
      var popup = info.querySelector('.shippingInfo__popup');
      if (!popup) return;
      var rect = popup.getBoundingClientRect();
      var gap = 16;
      var bottom = window.innerHeight;
      document.querySelectorAll('.enable_sticky_buttton, .cart-total.is-sticky, #PBarNextFrameWrapper').forEach(function (bar) {
        var r = bar.getBoundingClientRect();
        if (getComputedStyle(bar).position === 'fixed' && r.top > 0 && r.top < bottom) bottom = r.top;
      });
      var delta = 0;
      if (rect.bottom + gap > bottom) delta = rect.bottom + gap - bottom;
      var header = document.querySelector('.header-sticky.is-sticky, .sticky-header.is-sticky, header.is-sticky');
      var topLimit = header ? header.getBoundingClientRect().bottom : 0;
      if (rect.top - delta - gap < topLimit) delta = rect.top - gap - topLimit;
      if (delta) window.scrollBy({ top: delta, behavior: 'smooth' });
    });
  }, 0);
});
